function configUpdateSelect() {

  function update_condominios() {
    if(!window.condominios) return true
    let cat = $('#categoria_id').val();
    let sub = $('#subcategoria_id').val();
    let t = '<option value="">-- Selecione --</option>';
    for(let c of condominios){
      if(cat && c.categorias.indexOf(cat)==-1) continue;
      if(sub && c.subcategorias.indexOf(sub)==-1) continue;
      t += `<option value="${c.id}">${c.nome}</option>`
    }
    $('select[name=condominio_id]').html(t)
  }

  $('#categoria_id,#subcategoria_id').change(update_condominios)

	// update select

	function update_select(param, $select, url, db_value) {
		$select.children().remove();
		$select.append("<option value=''>-- Carregando... --</option>");

		$.post(url, {'item': param}, function(data) {

			$select.children().remove();
			$select.append("<option value=''>-- Selecione --</option>");

			$(data).each(function() {
				let optag = "<option value='"+this.value+"'";
				if(this.value == db_value) {
					optag += " selected ";
				}
				optag += ">"+this.label+"</option>";

				$select.append(optag);
        update_condominios();
			});

		}, 'json')
		.fail(function() {
			$select.html("<option value=''>-- Erro ao carregar os itens --</option>");
			//console.log('erro');
		});
	}
	
	// upt categorias
	if($(".sl-categoria").length > 0) {
		$('form').on('change', '.sl-categoria', function() {
			checkCategoria($(this));
		});

		function checkCategoria($jqobj) {
			let $sl_subcategoria = $('#' + $jqobj.attr('data-target'));
			let categoria = $jqobj.val();
			let db_value = $sl_subcategoria.attr('data-db-value');

			update_select(categoria, $sl_subcategoria, baseurl + 'admin/categorias/get_subcategorias_json', db_value);
		}

		// init
		$('.sl-categoria').each(function() {
			checkCategoria($(this));
		});
	}
}

export default configUpdateSelect
